// extracted by mini-css-extract-plugin
export var md = "_2l-4";
export var semantic = "_2l-5";
export var sm = "_2l-3";
export var text = "_2l-6";
export var toggleInput = "_2l-0";
export var toggleSwitch = "_2l-1";
export var xs = "_2l-2";